module.exports = __webpack_public_path__ + "img/bg-chat.23c937bf.png";